export default __webpack_public_path__ + "static/media/tete96.7df347e0.png";